// extracted by mini-css-extract-plugin
export default {"section":"ModalPayoutAccounts_section__IUyCN","sectionTitle":"ModalPayoutAccounts_sectionTitle__F0z44","name":"ModalPayoutAccounts_name__lY13M"};